// extracted by mini-css-extract-plugin
export default {"loader_style":"OpenAsgFromMail_loader_style__mjQR+"};